require("@fancyapps/fancybox");

$.fancybox.defaults.infobar = false;
$.fancybox.defaults.toolbar = false;
$.fancybox.defaults.smallBtn = true;
$.fancybox.defaults.buttons = [
  "zoom",
];
$.fancybox.defaults.clickOutside = "close";
$.fancybox.defaults.clickSlide = "close";
$.fancybox.defaults.arrows = false;

export const CONFIG = {
  TYPING_DELAY_BY_CHARACTER: 100,
  READING_DELAY_BY_CHARACTER: 20,
  HTML_MESSAGE_DEFAULT_WAIT: 100,
  IMAGE_DEFAULT_WAIT: 1000
};
